export class StartPractice extends Event {
    static eventName = 'StartPractice';

    constructor() {
        super(StartPractice.eventName)
    }
}

export class RatingEvent extends Event {
    public static eventName = 'RepWasRated';
    time: number

    constructor(public rating: string) {
        super(RatingEvent.eventName);
        this.rating = rating
        this.time = Date.now()
    }
}

export class AnswerSubmitted extends Event {
    static eventName = 'AnswerSubmitted'

    constructor() {
        super(AnswerSubmitted.eventName);
    }
}

export class ContinueButtonClicked extends Event {
    static eventName = 'continueButtonClicked'

    constructor() {
        super(ContinueButtonClicked.eventName)
        this.time = Date.now()
    }

    get command(): string {
        return 'continue'
    }
}

export class AutoCheckOverruled extends Event {
    static eventName = 'autoCheckOverruled'

    constructor() {
        super(AutoCheckOverruled.eventName)
    }

    get command(): string {
        return 'overrule'
    }
}


export class ReturnRepClicked extends Event {
    static eventName = 'returnRepClicked'

    constructor() {
        super(ReturnRepClicked.eventName)
    }
}


export class ActionFailed extends Event {
    static eventName = 'actionFailed'

    constructor(public message: string, public error:Error) {
        super(ActionFailed.eventName)
        this.message = message
        this.error = error
    }
}